<template id="bs-modal">
	<!-- MODAL -->    
	<div class="modal fade checkin" id="checkinModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
		<div class="modal-dialog modal-lg" role="document">
			<div v-if="checkin" class="modal-content drop-down-hover">
				<div class="modal-header pb-0 pt-2 d-flex align-items-end" :class="checkin.checkin_type.css_class_name">
					<div v-if="checkin.checkinable.photo_url" class="physician-photo rounded-circle circle-cropped avatar-lg mr-2">
						<img class="img-fluid" :src="checkin.checkinable.photo_url" alt="Avatar">
					</div>
					<h2 class="mb-0 text-white flex-grow-1">{{checkin.checkin_type.label}} with {{checkin.checkinable.display_name}}</h2>
					<div>
						<div v-if="checkin.can.update" class="drop-down text-right">
						  <a href="#" class="show-on-hover text-right" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-test="contextMenu">
						    <i class="far fa-ellipsis-h text-2xl text-white"></i>
						  </a>
						  <div class="dropdown-menu dropdown-menu-right py-0" aria-labelledby="dropdownMenuLink">
						  	<span class="dropdown-item" @click="startEditing()" data-test="editCheckinLink">Edit Checkin</span>
						  </div>
						</div>

						<div class="text-white text-right">{{ moment(checkin.created_at).format('MMM D, YYYY')}}</div>	
					</div>
				</div>

				<div class="modal-body pb-0">
					<div class="container-fluid">
						<div v-if="editing" class="row" style="margin-top:-1rem;">
							<div class="col-5 pt-3 pb-3">
								<div class="form-group">
									<label>Check-in Type</label>
									<v-select
										label="label"
										:options="options.checkin_types"
										:reduce="label => label.id"
										v-model="form.checkin_type_id"
										data-test="editCheckinType" />
									<has-error :form="form" field="checkin_type_id" />
								</div>

								<div class="form-group">
									<label>Services Lines Promoted <span class="text-muted"> - Optional</span></label>
									<v-select
		                                multiple
		                                label="label"		                                
		                                :options="options.service_lines"
		                                :reduce="label => label.id"
		                                v-model="form.service_lines"
		                                data-test="editCheckinServiceLines" />
		                        </div>

		                        <div class="form-group">
		                            <label>Assets Used <span class="text-muted"> - Optional</span></label>    
									<v-select
										multiple
										label="name"
										:options="options.assets"
										:reduce="name => name.id"
										v-model="form.assets"
										data-test="editCheckinAssets">
										<template slot="option" slot-scope="option">
											<img :src="option.thumbnail_url" width=20 height=20>
											{{ option.name }}
										</template>
									</v-select>
								</div>

								<div class="form-group">
									<label>Route <span class="text-muted"> - Optional</span></label>
									<v-select
										label="title"
										:options="options.routes"
										:reduce="title => title.id"
										v-model="form.route_id"
										data-test="editCheckinRoute" />											
								</div>

								<div class="form-group">
									<label>Campaign <span class="text-muted"> - Optional</span></label>
									<v-select
										label="title"
										:options="options.campaigns"
										:reduce="title => title.id"
										v-model="form.campaign_id"
										data-test="editCheckinCampaign" />											
								</div>

								<div class="button-wrap pt-3 pr-3 pl-3 text-right">
									<span class="btn btn-outline-secondary" @click="stopEditing()">Cancel</span>
									<button :disabled="form.busy" type="submit" class="btn btn-primary" @click="updateCheckin()" data-test="saveEditCheckinButton">Save Check-in</button>
								</div>								
							</div>

							<div class="col-7 pt-5 pb-3" style="background:#e4e7ea; box-shadow:inset 7px 0 9px -7px rgba(0,0,0,0.4)">
								<div class="form-group">
									<label>Checkin Notes <span class="text-muted"> - Optional</span></label>
									<vue-editor 
						                :editor-toolbar="config.editor.toolbar"
						                v-model="form.notes"
						                data-test="editCheckinNotes"
						            />
								</div>
							</div>
						</div>

						<div v-else class="row">
							<div class="col-md-4">
								<div v-if="checkin.service_lines.length > 0" class="mb-3" >
									<div class="section-label">Promoted</div>
									<span class="badge badge-info text-white" v-for="service_line in checkin.service_lines" v-html="service_line.label"></span>
								</div>

								<div v-if="checkin.assets.length > 0" class="mb-3" >
									<div class="section-label">Delivered</div>
									<template v-for="asset in checkin.assets">
										<img :src="asset.thumbnail_url" class="img-thumbnail" style="max-width:200px"><br>
										{{ asset.name }}
									</template>
								</div>

								<div class="mb-3" >
									<div class="section-label">Route Info:</div>
									<div v-if="checkin.route_visit" @click="closeModal()">
										<i class="fal fa-route"></i> {{ checkin.route_visit.type === 'planned' ? 'Planned visit' : 'Unplanned checkin' }} on <router-link :to="{ name: 'routes.show', params: { id: checkin.route_visit.route_id} }">route</router-link>
									</div>
									<div v-else>
										Not part of a route.
									</div>	
								</div>

								<div v-if="checkin.campaign_visit" class="mb-3">
									<div class="section-label">Campaign Info:</div>
									<div  @click="closeModal()">
										<i class="fal fa-fire-alt mr-1"></i><router-link :to="{ name: 'campaigns.show', params: { id: checkin.campaign_visit.campaign_id } }">Open Campaign</router-link>
									</div>
								</div>								
							</div>

							<div class="col-md-8">
								<div class="section-label">Notes</div>		
								<div v-if="checkin.notes">
									<span v-html="checkin.notes"></span>
								</div>
								<p v-else class="text-muted"><em>No notes entered</em></p>								
							</div>

							<div class="checkin-user col-12 d-flex align-left text-muted mt-3 py-2">
								<span class="mr-1">Checkin made by:</span>
								<div v-if="checkin.checkin_user && checkin.checkin_user.photo_url" class="rounded-circle circle-cropped avatar-sm mr-1">
									<img class="img-fluid" :src="checkin.checkin_user.photo_url">
								</div>
			                    <span v-if="checkin.checkin_user">{{ checkin.checkin_user.display_name }}</span>
			                    <span v-else>unknown</span>
							</div>

						</div>
					</div>
				</div>

			</div>
		</div>
	</div>    
</template>

<script>
	import { mapState } from 'vuex';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';

  	export default {

        components: {
            HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form            
        },

	    props: {
	    	showing_checkin: Object,
	    },

	    data () {
	        return {
	        	editing: false,
	        	checkin: null,
	        	form: {},
	        	options_loaded: false,
	        }
	    },

	    mounted () {
	    	this.$store.dispatch('fetchAssets');
    		// if (!this.options_loaded) {
	    	// 	this.fetchAllCheckinTypes();
	    	// 	this.fetchAllServiceLines();
	    	// 	this.fetchAllAssets();
	    	// 	this.fetchAllRoutes();
    		// 	this.options_loaded = true;
	    	// }
	    },


	    methods: {
	    	closeModal() {
	    		jQuery('.modal').modal('hide');
	    		jQuery('.modal-backdrop').remove();
	    	},

	    	startEditing() {
		        this.form = new Form({
		        	physician_id:  		this.showing_checkin.physician_id,
		            checkin_type_id:    this.showing_checkin.checkin_type_id,
		            service_lines: 		this.showing_checkin.service_lines.map(service_line => service_line.id),
		            assets: 			this.showing_checkin.assets.map(asset => asset.id),
		            notes: 				this.showing_checkin.notes,
		            route_id: 			this.showing_checkin.route_visit ? this.showing_checkin.route_visit.route_id : null,
		        }); 

	    		this.editing = true;
	    	},

	    	stopEditing() {
	    		this.editing = false;
	    	},

			updateCheckin () {
		    	this.form.put('/api/checkins/' + this.showing_checkin.id).then(({ data }) => { 
	        		//load up the brand new checkin form the site
		        	axios.get('/api/checkins/' + data.id).then(({data}) => {
	                    this.$root.$emit('checkin_updated', data);
	                    this.editing = false;
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            icon: 'success',
                            title: 'Checkin saved',
                        });	                    
	        		})
		        })
		    },
    	},

    	computed: {
    		...mapState(['config', 'options'])
    	},

    	watch: {
    		showing_checkin() {
    			this.checkin = this.showing_checkin;
    		}
    	},
  };
</script>

<style scoped>
	.button-wrap { border-top:1px solid #e4e7ea; margin:0 -1rem; }
</style>